import * as React from 'react';
import classNames from 'classnames';
import { ButtonGroup } from '@cvent/carina/components/ButtonGroup';
const { ThemeProvider } = require('@cvent/carina-theme-provider');
import { ThemeProvider as V1ThemeProvider } from '@cvent/carina/components/ThemeProvider';
import wsCarinaTheme from '../../configs/carina-theme';

const styles = require('./MapZoomControl.scss');
const controlStyles = require('./MapControl.scss');

interface Props {
    onChange: (incr: 1 | -1) => void;
}

export default function MapZoomControl(props: Props) {
    return (
        <V1ThemeProvider theme={wsCarinaTheme}>
            <ThemeProvider theme={wsCarinaTheme}>
                <div className={classNames(controlStyles.mapControls, styles.zoomControl)}>
                    <ButtonGroup
                        autoWidth
                        onChange={(idx: number) => {
                            if (idx !== null) {
                                props.onChange(idx === 0 ? 1 : -1);
                            }
                        }}
                        selected={-1}
                    >
                        <ButtonGroup.Item text='+' />
                        <ButtonGroup.Item text='–' />
                    </ButtonGroup>
                </div>
            </ThemeProvider>
        </V1ThemeProvider>
    );
}
